import React from 'react';
import NavigationMenuItem from "./menu-item";
import NavigationSection from "../../../core/model2/navigation/navigation-section";
import {Feature} from "../../../core/gd/access-control/feature-access/const";

type State = {
    currentRouteFragment    : string,
    showPopover             : boolean,
    reRender?               : boolean
}

type Props = {
    className?              : string,
    level?                  : number
    name                    : string,
    icon                    : string,
    url                     : string,
    upgradeRequiredFeature  : Feature
    navigationSection?      : NavigationSection
    exactUrl?               : boolean,
    saveUrl?                : boolean
}

export default class NavigationMenuItemUrl extends React.Component<Props, State> {

    static defaultProps = {
        upgradeRequiredFeature : false
    };

    constructor(props:Props) {
        super(props);

        this.state = {
            currentRouteFragment    : gd.router.history.fragment || '',
            showPopover             : false,
        };
    }

    componentDidMount = () => {
        gd.router.on('route', this.onRoute);
    };

    componentWillUnmount = () => {
        gd.router.off('route', this.onRoute);
    };

    onRoute = () => {
        this.setState({currentRouteFragment: gd.router.history.fragment || ''});
    };

    sessionDataChanged() {
        this.setState({
            reRender: true
        });
    }

    getCurrentRouteFragment = () => gd.router.history.fragment || ''

    render() {
        //includes  string function ... tipo esi est' to vse ... po idee starts from ?
        const isSelected = (this.props.exactUrl)
            ?this.getCurrentRouteFragment() === this.props.url
            :this.getCurrentRouteFragment().includes(this.props.url);


        // {...this.props}
        return <NavigationMenuItem className                = {this.props.className}
                                   name                     = {this.props.name}
                                   level                    = {this.props.level}
                                   selected                 = {isSelected}
                                   icon                     = {this.props.icon}
                                   url                      = {this.props.url}
                                   navigationSection        = {this.props.navigationSection}
                                   upgradeRequiredFeature   = {this.props.upgradeRequiredFeature}
                                   saveUrl                  = {this.props.saveUrl}
        />
    }

}

